import { fromJS } from 'immutable';

import { ApiDashboard,UserToken } from '../../../helper/HelperAuth'
import {
    GetPushFormatDistribution,
} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'


export default (body, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiDashboard + 'push-format-distribution';

    var query = body

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'template-type':type,

        },
        body : JSON.stringify(query)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    var responseData = [];
    var finalData = [];
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('push-format');
        for (var i = 0; i < data.size; i++) {
            responseData = []
            let dataDetail = data.get(i)
            responseData['name'] = dataDetail.get('format')
            if(parseInt(dataDetail.get('total')) == 0){
            responseData['value'] = 1
            responseData['extension'] = 0
            }else {
            responseData['value'] = parseInt(dataDetail.get('total'))
            responseData['extension'] = 1
        }
           
            finalData.push(responseData)
        }
        data = finalData
    }

    dispatch({ type: GetPushFormatDistribution, data:data });
    return data
};